import { useSelector } from '@lingoda/hooks';
import { studentPreferencesSelector } from '@lingoda/students';
import type { AnnouncementId } from '../model/announcement';

export const useAnnouncementBanner = (preference: AnnouncementId) => {
    const preferences = useSelector(studentPreferencesSelector);

    return !preferences?.dismissedWidgets?.[preference];
};
